import { Component, Host, Prop, h } from '@stencil/core';

import { onAutoCheckFullReportClick } from '../../../../actions/actions.autocheck';
import { HistoryIcon } from '../../../../interfaces/interface.consumer-market-confidence';

@Component({
  tag: 'confident-vehicle-history-report',
  styleUrl: 'confident-vehicle-history-report.css',
})
export class ConfidentVehicleHistoryReport {
  @Prop() autoCheckFullReportLink: string = '';
  @Prop() reportGeneratedOnDate: string = '';
  @Prop() vin: string = '';
  @Prop() shouldDisplayConfidentVehicleHistoryReport: boolean = false;
  @Prop() historyIcons: HistoryIcon[] = [];
  render() {
    const { autoCheckFullReportLink, reportGeneratedOnDate, vin, historyIcons } = this;

    if (!this.shouldDisplayConfidentVehicleHistoryReport) {
      return null;
    }

    return (
      <Host>
        <div class="@container">
          <div class="bg-clrs-white rounded-lg shadow-drop py-4 pr-4" data-testId="confident-vehicle-history-report">
            <div class="flex flex-col text-sm text-black font-open-sans @xs:px-6 @md:px-12">
              <h3 class="mb-5 font-extrabold text-lg font-montserrat">Vehicle History Report</h3>
              <div class="mb-2 text-sm">
                VIN: <strong>{vin}</strong>
              </div>
              <div class="mb-2 text-sm">
                Report Generated On: <strong>{reportGeneratedOnDate}</strong>
              </div>
              <span>Information provided by AutoCheck&#174;</span>
              <ico-hyperlink href={autoCheckFullReportLink} target="_blank" class="block @sm:inline mt-1 mb-3" onClick={() => onAutoCheckFullReportClick()}>
                Get full report
              </ico-hyperlink>
              <div class="grid grid-cols-3 mb-2 gap-2">
                {historyIcons.map((iconInfo, index) => (
                  <history-icon key={`${iconInfo.icon}-${index}`} icon={iconInfo.icon} label={iconInfo.label} />
                ))}
              </div>
              <div class="text-xs text-center">(This is not a full history report)</div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
